"use client";

import React, { useState, useEffect } from "react";
import { Box, Container } from "@mui/material";
import LogoLoop from "../components/LogoLoop/LogoLoop";
import "../app/globals.css";
import { IMAGES } from "../constants/images";
import i18n from "../i18n";

const LogoCarousel = () => {
  const [currentLang, setCurrentLang] = useState("en");

  useEffect(() => {
    setCurrentLang(i18n.language || "en");
    const handleLangChange = (lang) => setCurrentLang(lang);
    i18n.on("languageChanged", handleLangChange);
    return () => i18n.off("languageChanged", handleLangChange);
  }, []);

  const isRTL = currentLang === "ar";

  const imageLogos = [
    {
      src: IMAGES.COMPANY_1,
      alt: "Top recruiting software trusted by 500+ companies worldwide",
    },
    {
      src: IMAGES.COMPANY_2,
      alt: "Top recruiting software trusted by 500+ companies worldwide",
    },
    {
      src: IMAGES.COMPANY_3,
      alt: "Top recruiting software trusted by 500+ companies worldwide",
    },
    {
      src: IMAGES.COMPANY_4,
      alt: "Top recruiting software trusted by 500+ companies worldwide",
    },
    {
      src: IMAGES.COMPANY_5,
      alt: "Top recruiting software trusted by 500+ companies worldwide",
    },
    {
      src: IMAGES.COMPANY_6,
      alt: "Top recruiting software trusted by 500+ companies worldwide",
    },
    {
      src: IMAGES.COMPANY_7,
      alt: "Top recruiting software trusted by 500+ companies worldwide",
    },
  ];

  return (
    <Container
      maxWidth={false}
      sx={{
        px: { xs: 2, sm: 3, md: 4, lg: 2, xl: 39 },
        mt: { xs: "4%", sm: "3%", md: "2.5%", lg: "-1%" },
        direction: "ltr", // ← Always LTR, carousel RTL se affect na ho
      }}
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
          overflow: "hidden",
          height: { xs: "100px", sm: "120px", md: "140px" },
          "& ul": { listStyle: "none", padding: 0, margin: 0 },
          "& li": { listStyle: "none" },
        }}
      >
        {/* Left Fade */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: { xs: "50px", sm: "80px", md: "120px", lg: "200px" },
            background:
              "linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 30%, rgba(255,255,255,0) 100%)",
            zIndex: 2,
          }}
        />

        {/* Right Fade */}
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            width: { xs: "50px", sm: "80px", md: "120px", lg: "200px" },
            background:
              "linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 30%, rgba(255,255,255,0) 100%)",
            zIndex: 2,
          }}
        />

        <LogoLoop
          logos={imageLogos}
          speed={100}
          direction={isRTL ? "right" : "left"} // ← Arabic mein right direction
          logoHeight={70}
          gap={70}
          pauseOnHover
          scaleOnHover
          fadeOut
          fadeOutColor="#ffffff"
          ariaLabel="Social Media Posts"
        />
      </Box>
    </Container>
  );
};

export default LogoCarousel;
